module.exports = __webpack_public_path__ + "9be5cf1836f2f547d886a9f2ba988545.pdf";